import instance from "./instance";
export const findAll = () => {
    return instance.get(`/filters`)
        .then(response => ({ response }))
        .catch(error => ({ error }));
};
